<template>
  <a-dialog
      ref="dialog"
      name="version_changelog"
      :toolbar="true"
      :persistent="true"
      :visible="visible"
      @close="closed">
    <span slot="title">
      {{ $t('title', { version }) }} <v-icon>mdi-party-popper</v-icon>
    </span>
    <div slot="content" class="pt-8">
      <div class="text-center">
        <v-icon style="font-size: 4em;" color="orange">mdi-hand-wave-outline</v-icon>
        <div class="text-h4 mt-4">{{ $t('healine') }}</div>
        <div class="mt-1">{{ $t('sub-headline')}}</div>
      </div>

      <p class="text-h5">{{ $t('changelog') }}</p>
      <ul>
        <li><v-icon color="primary">mdi-file-clock-outline</v-icon> <strong>Ajout d'un nouveau système d'export permettant la génération de rapport personnalisé</strong>, planification de rapports par jour/semaine/mois et envoie automatique par email.</li>
        <li><v-icon color="primary">mdi-file-table-outline</v-icon> <strong>Ajout de l'URL positionnée</strong> dans l'export de données brut du suivi de positions.</li>
        <li><v-icon color="primary">mdi-speedometer</v-icon> <strong>Mise à jour et amélioration des proxy</strong> afin d'améliorer la stabilité et la vitesse des crawl.</li>
        <li><v-icon color="primary">mdi-sort</v-icon> <strong>Ajout du groupage et du tri par pays / langue</strong> sur le tableau de suivi des positions.</li>
        <li>Modification du pricing concernant les positions datacenters par jour afin d'éviter les abus d'utilisation (nous avons détecté plusieurs bots ralentissant l'application).</li>
        <li>Correction d'un bug de listing pouvant apparaitre sur les notes / tags lorsqu'on enlève la pagination sur le suivi des positions.</li>
        <li>Correction d'un problème de timer pour le renvoi de SMS à l'inscription.</li>
        <li>Corrections de traductions anglaises diverses dans l'interface.</li>
        <li>Correction d'un bug d'affichage du champ de groupage sur le suivi des positions.</li>
        <li>Améliorations diverses d'interface (boutons manquant sur les dialogs, normalisation de champs ...).</li>
        <li>Optimisation des composants et des dépendances afin d'alléger la taille du client.</li>
        <li>Suppression des mentions Bêta <v-icon>mdi-party-popper</v-icon></li>
      </ul>
    </div>
  </a-dialog>
</template>

<style scoped>
  li {
    margin-bottom: 6px;
  }
</style>

<script>
export default {
  name: 'VersionChangeLog',
  data () {
    return {
      version: 'v1.0.0',
    }
  },
  computed: {
    visible () {
      // Stop sending the changelog
      return false

      if (this.$account.isVerified && !this.$account.isImpersonated && this.$account.current.meta.cgu_accepted_at) {
        const closedVersion = this.$cookie.get('changelog_closed')
        return closedVersion !== this.version;
      }

      return false
    },
  },
  methods: {
    closed () {
      this.$cookie.set('changelog_closed', this.version, { expires: 30 })
      this.$reset()
    }
  }
}
</script>

<i18n>
{
	"en": {
		"changelog": "Changelog (in french):",
		"healine": "Check Position evolves",
		"promotion-text": "For the occasion, until June 30, take advantage of 30% off an annual subscription with the promotion code",
		"sub-headline": "Thanks to you, lots of new features and an new version!",
		"title": "Update {version}"
	},
	"es": {
		"changelog": "Changelog (en francés):",
		"healine": "Comprobar posición evoluciona",
		"promotion-text": "Para la ocasión, hasta el 30 de junio, aprovecha un 30% de descuento en una suscripción anual con el código de promoción",
		"sub-headline": "¡Gracias a ti, muchas funciones nuevas y un V1 en línea!",
		"title": "Actualizar {version}"
	},
	"fr": {
		"changelog": "Changelog :",
		"healine": "Check Position évolue",
		"promotion-text": "Pour l'occasion, jusqu'au 30 juin profitez de 30% de réduction sur un une souscription annuelle avec le code promotion",
		"sub-headline": "Grâce à vous, plein de nouveautés et une V1 en ligne !",
		"title": "Mise à jour {version}"
	},
	"it": {
		"changelog": "Changelog (in francese):",
		"healine": "Check Position evolve",
		"promotion-text": "Per l'occasione, fino al 30 giugno, approfitta del 30% di sconto su un abbonamento annuale con il codice promozionale",
		"sub-headline": "Grazie a voi, tante novità e una nuova versione online!",
		"title": "Aggiornamento {version}"
	},
	"pt": {
		"changelog": "Changelog (em francês):",
		"healine": "Check Position evolui",
		"promotion-text": "Para a ocasião, até 30 de junho, aproveite 30% de desconto numa subscrição anual com o código de promoção",
		"sub-headline": "Graças a vós, muitas novidades e uma nova versão online!",
		"title": "Atualização {version}"
	},
	"pl": {
		"changelog": "Lista zmian (po francusku):",
		"healine": "Check Position ewoluuje",
		"promotion-text": "Z tej okazji do 30 czerwca skorzystaj z 30% zniżki na roczną subskrypcję z kodem promocyjnym",
		"sub-headline": "Dzięki Tobie wiele nowych funkcji i nowa wersja!",
		"title": "Aktualizacja {version}"
	}
}
</i18n>